<!-- 裁判桌号设置 -->
<template>
    <div>
     <div class="title">第{{round}}轮 裁判设置</div>
      <el-row class="red mg-t-20">注意：裁判长、编排长设置桌号默认所有，其它桌号每桌只能指定一名裁判。</el-row>
     <referee :publishId="pubId" :show="true" @message="handleDeskReferee" style="width:60%"></referee>
     <!-- <el-button class="mg-tb-20" type="primary" @click="handleReferee">一键设置裁判</el-button>
     <el-button class="mg-tb-20" type="primary" @click="handleDeskReferee">设置某一桌裁判</el-button> -->
    
     <el-table :data="tableData" class="set-desk custom-table2" border style="margin-top:10px;width:50%">
        <el-table-column
        prop="deskNo"
        label="桌号"
        align="center"
        >
        </el-table-column>
        <el-table-column
            prop="userId"
            label="裁判账号"
            align="center"
           >
            <!-- <template slot-scope="scope" >
                <el-input v-model="scope.row.userId" style="width:80px" 
                @blur="updateReferee(scope.row)"></el-input>
            </template>        -->
        </el-table-column>   
        <el-table-column
        prop="username"
        label="裁判名称"
        align="center"
       >
            <!-- <template slot-scope="scope" >
            <el-input v-model="scope.row.username" style="width:200px" 
                @blur="updateReferee(scope.row)"></el-input>
            </template>        -->
        </el-table-column>
    </el-table>
    </div>
 </template>
 
 <script>
 import { mapState } from 'vuex'
 import Referee from '../../publish/components/refereeQuery'
 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     components:{
        Referee,
     },
     data() {
         return {
            refereeList: [],
            tableData: [],
         }
     },
     created() {
     },
     mounted() {

     },
     computed:{
        ...mapState(['round'])
     },
     methods: {
            // 裁判桌号查询
            initData(){
                let params = {
                    opcode: this.$code.PubDeskQuery,
                    i_serial_mark: this.pubId,
                    i_desk_no: '',
                    v_referee: '',
                    v_referee_no: ''
                }
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable
                        if(result.length > 0){
                            this.tableData = result.map(item=>{
                                return{
                                    deskNo: item['桌号'],
                                    userId: item['裁判账号'],
                                    username: item['裁判'],
                                }
                            })
                            // console.log("桌号",this.tableData)
                        }else{
                            this.$message.error('请先设置！')
                        }                   
                    }
                })      
            },  
            getReferee(){
                let params = {
                    opcode:this.$code.RefereeQuery,
                    i_serial_mark: this.pubId
                };
                this.$api.requestAPI(params).then(res =>{
                    if(res.IsSuccess){                 
                        if(res.Data.SumCount > 0){                        
                            let result = res.Data.DataTable;
                            this.refereeList = result.map((item,index) =>{
                                return{
                                    index: index+1,
                                    userId: item['裁判账号'],
                                    serialMark: item['赛事标识'],
                                    username: item['裁判'],
                                    sponsorPosition: item['职务'],
                                }
                            })
                        }else{                           
                            this.refereeList = []
                        }
                    }
                }).catch(error =>{
                    console.log(error);
                })
            },
            updateReferee(row,deskNo){
                let params = {
                    opcode: this.$code.PubDeskSet,
                    i_serial_mark: this.pubId,
                    i_desk_no: deskNo,
                    v_referee: row.username,
                    v_referee_no: row.userId,
                }
                // console.log(params)
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        this.$message.success('设置成功')      
                        this.initData()           
                        this.getReferee()
                    }else{
                        this.$message.error(res.Message)
                    }
                })
            },            
            // 一键设置裁判
            handleReferee(){
                if(this.refereeList.length > 0){
                    let deskArr = this.tableData                    
                    let refereeArr = this.refereeList
                    let newArr = []
                    if(this.refereeList.length >= this.tableData.length ){
                        for (const obj of deskArr){
                            let ref =  refereeArr.filter(i=> i.index === obj.deskNo)
                            newArr.push({
                                deskNo:obj.deskNo,
                                username: ref[0].username,
                                userId: ref[0].userId
                            })                        
                        }
                        if(newArr.length > 0){
                            for (const item of newArr) {
                                this.updateReferee(item)
                            }                       
                        }
                    }else{
                        this.$message.error('裁判数量少于桌数不能一键设置，请先添加裁判！')
                    }                   
                }else{
                    this.getReferee()
                    this.$message.error('请先添加裁判！')
                }
            },
            // 设置某一桌的裁判
            handleDeskReferee(value,deskNo){
                if(deskNo.length > 0){
                    for (const item of deskNo) {
                        this.updateReferee(value,item)
                    }   
                }
            }
     }
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 28px;
 }
 table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 28px;
   }
   tr:nth-child(even) {
     background-color: lightblue;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 30px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
   .set-desk >>> .el-table{
        font-size: 16px;
    }
    .set-desk >>> .el-table__cell{
        font-size: 16px;
    }
 </style>


// WEBPACK FOOTER //
// src/views/team/components/setDesk.vue